module.exports = __webpack_public_path__ + "img/search_class.c426d131.png";